<template>
  <section class="how-to">
    <div class="l-page-content">
      <h1 class="section-title how-to__title">Как это работает</h1>
      <ul class="how-to__step-list">
        <li class="how-to__step-item">
          <i class="how-to__step-icon how-to__step-icon--1" />
          <p class="how-to__step-text">
            Вы
            <a href="https://auth.motmom.com/activation" target="_blank" class="how-to__link">регистрируетесь</a>
            на сайте и настраиваете свою систему лояльности
          </p>
        </li>

        <li class="how-to__step-item1">
          <i class="how-to__flow-icon how-to__flow-icon--1" />
        </li>

        <li class="how-to__step-item">
          <i class="how-to__step-icon how-to__step-icon--2" />
          <p class="how-to__step-text">
            Покупателям начисляются бонусные рубли за покупки через терминал или кассове ПО
          </p>
        </li>

        <li>
          <i class="how-to__flow-icon how-to__flow-icon--2" />
        </li>

        <li class="how-to__step-item">
          <i class="how-to__step-icon how-to__step-icon--3" />
          <p class="how-to__step-text">
            Когда покупатель хочет потратить бонусные рубли,
            Вы списываете их через терминал или кассовое ПО
          </p>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss">
.how-to {
  background: #1f1742;

  &__title {
    color: #fefefe;
  }

  &__step-list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;

    @include device-until(tablet) {
      flex-wrap: wrap;
    }
  }

  &__step-item {
    flex: 1 1 0px;
    width: auto;
    margin-right: 1.5rem;
    margin-left: 1.5rem;
    text-align: center;
    margin-bottom: 2.5rem;
    color: #fefefe;

    @include device-until(tablet) {
      width: 100%;
      flex: auto;
    }
  }

  &__link {
    color: #ff61a1;
  }

  &__step-text {
    font-weight: 300;
    font-size: 1.125rem;
    line-height: 1.5rem;
    margin: 3rem 0;
    color: #fefefe;
  }

  &__step-icon {
    display: inline-block;
    width: 190px;
    height: 140px;

    &--1 {
      background: url('~@/assets/images/icons/how-to-step1.png');
    }

    &--2 {
      background: url('~@/assets/images/icons/how-to-step2.png');
    }

    &--3 {
      background: url('~@/assets/images/icons/how-to-step3.png');
    }
  }

  &__flow-icon {
    display: flex;
    align-items: center;
    height: 8.5rem;

    @include device-until(desktop) {
      display: none;
    }

    &::before {
      content: '';
      display: inline-block;
      width: 98px;
      height: 45px;
    }

    &--1::before {
      background: url('~@/assets/images/icons/how-to-flow1.png');
    }

    &--2::before {
      background: url('~@/assets/images/icons/how-to-flow2.png');
    }
  }
}
</style>
